import React  from 'react';
import './../../css/CardRedirection.css';
import {connect} from 'react-redux';
import {OnTooManyCodesRequested,OnTooManyCodesReqCancel} from './../../components/SiteCat/SiteCat';
import {unProcessableEntity} from './../../constants/merchantData';

class TooManyCodesRequestedPage extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }
  componentDidMount() {
    OnTooManyCodesRequested(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode,
      cancelUrlData
    });
  }
  handleCancel = event => {
    OnTooManyCodesReqCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }


    render() {

        return(
        <React.Fragment>
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
              <div className="try-again-header">You have requested too many codes.</div>
              <div className="contact-us" x-ms-format-detection="none">We apologize for any inconvenience. Please contact us at
                                              <b> 1-800-347-2655</b> for immediate assistance and access to your account.</div>
              <div className="try-again-link"><button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
            </div>
          </div>
          </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(TooManyCodesRequestedPage);